import React from 'react'
import { SiteHeader } from './SiteHeader'
import { SiteFooter } from './SiteFooter'

type Props = {
  children: React.ReactNode
}

export function PageLayout({ children }: Props) {
  return (
    <div id="top" className="page-layout">
      <SiteHeader />
      <main>{children}</main>
      <SiteFooter />
    </div>
  )
}
